import React from 'react';
import SEO from '../components/SEO';
import AuditForm from '../components/AuditForm';
import { useT } from '../i18n';

export default function FreeAuditPage() {
  const { lang } = useT();
  const isEs = lang === 'es';
  return (
    <>
      <SEO
        title={isEs ? 'Auditoría IA Gratis para tu Restaurante' : 'Free AI Audit for Your Restaurant'}
        description={
          isEs
            ? 'Descubre en 2 minutos cómo aparece tu restaurante en Google y en las búsquedas con IA — auditoría gratuita, sin compromiso.'
            : 'Find out in 2 minutes how your restaurant shows up on Google and AI search — free audit, no commitment.'
        }
        path="/free-audit"
      />
      <section className="bg-[#1B1F24] pt-32 pb-14 lg:pt-36 lg:pb-20" data-testid="free-audit-hero">
        <div className="max-w-4xl mx-auto px-6">
          <p className="text-[#FF9B4A] text-xs font-bold tracking-[3px] uppercase">
            {isEs ? 'Auditoría gratuita · 2 minutos' : 'Free audit · 2 minutes'}
          </p>
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            {isEs ? '¿Aparece tu restaurante en las búsquedas con IA?' : 'Is your restaurant showing up in AI search?'}
          </h1>
          <p className="mt-4 text-base text-neutral-400 max-w-2xl">
            {isEs
              ? '8 de cada 10 comensales ya eligen restaurante a través de Google o buscadores con IA. Te decimos cómo estás — y cómo podrías estar.'
              : '8 out of 10 diners now pick restaurants through Google or AI-powered search. We tell you where you stand — and where you could be.'}
          </p>
          <a href="/score" data-testid="free-audit-score-link"
            className="mt-6 inline-flex items-center gap-2 rounded-full border border-[#FF9B4A]/50 bg-[#F77F11]/10 px-5 h-11 text-[13.5px] font-bold text-[#FF9B4A] hover:bg-[#F77F11]/20 transition-colors">
            ⚡ {isEs ? 'O consigue tu Restaurant Operating Score™ en 30 segundos →' : 'Or get your Restaurant Operating Score™ in 30 seconds →'}
          </a>
        </div>
      </section>
      <AuditForm />
    </>
  );
}
